/*eslint no-undef: */
// import Vue from 'vue';
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);

export default new VueI18n({
  locale: 'zh',
  silentTranslationWarn: true,
  messages: {
    'zh': require('@/assets/i18n/zh.json'),
    'en': require('@/assets/i18n/en.json')
  }
})